import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import gradPrograms, { Action as GradProgramsAction } from './gradPrograms';

// eslint-disable-next-line import/no-default-export
export default combineReducers<
  {
    gradPrograms: typeof gradPrograms;
  },
  GradProgramsAction
>({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  gradPrograms,
});
